module.exports = __webpack_public_path__ + "static/media/kyc_document_details.c790be78.svg";